export default {
  Invest: 1, // chi đầu tư theo dự án
  InvestCapital: 2, // chi đầu tư theo nguồn
};
